export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果您取消交易，它将在不完成操作的情况下关闭。"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您确定要取消交易吗？"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["是的，取消"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不，保持活跃"])}
}